export function validateDocument(documento: string | number): boolean {
    const cpfRegex = /^[0-9]{11}$/ // formato: 11 dígitos numéricos
    const cnpjRegex = /^[0-9]{14}$/ // formato: 14 dígitos numéricos

    // Remove caracteres especiais do documento
    documento = String(documento).replace(/[^\d]+/g, '')
    if (cpfRegex.test(documento)) {
        // valida CPF
        const cpf = documento.replace(/[^\d]+/g, '')
        if (cpf.length !== 11) {
            return false
        }

        let sum = 0
        let rest

        for (let i = 1; i <= 9; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
        }

        rest = (sum * 10) % 11

        if (rest === 10 || rest === 11) {
            rest = 0
        }

        if (rest !== parseInt(cpf.substring(9, 10))) {
            return false
        }

        sum = 0

        for (let i = 1; i <= 10; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
        }

        rest = (sum * 10) % 11

        if (rest === 10 || rest === 11) {
            rest = 0
        }

        if (rest !== parseInt(cpf.substring(10, 11))) {
            return false
        }

        return true
    } else if (cnpjRegex.test(documento)) {
        // valida CNPJ
        const cnpj = documento.replace(/[^\d]+/g, '')
        if (cnpj.length !== 14) {
            return false
        }

        // Valida CNPJ
        let soma = 0
        let pos = 5
        let dv1 = 0
        let dv2 = 0

        for (let i = 0; i < 12; i++) {
            soma += parseInt(documento.substring(i, i + 1)) * pos
            pos--
            if (pos < 2) {
                pos = 9
            }
        }

        dv1 = soma % 11 < 2 ? 0 : 11 - (soma % 11)

        soma = 0
        pos = 6

        for (let i = 0; i < 13; i++) {
            soma += parseInt(documento.substring(i, i + 1)) * pos
            pos--
            if (pos < 2) {
                pos = 9
            }
        }

        dv2 = soma % 11 < 2 ? 0 : 11 - (soma % 11)

        if (
            dv1 !== parseInt(documento.substring(12, 13)) ||
            dv2 !== parseInt(documento.substring(13, 14))
        ) {
            return false
        }

        return true
    } else {
        return false
    }
}
